<template>
    <div>
        <TitleAndExplanation v-if="title || explanation" :title="title" :explanation="explanation"/>
        <ValidationProvider :rules="rules" v-slot="{ errors }">
            <div class="input-field-container" >
                <div class="input-field" :class = "{ 'error': errors[0] }">
                    <label 
                        :class="{ active: inputValue || isFocused }"
                        for="text-input" 
                        v-if="label !== ''"> {{ label }}</label>
                    <input
                        :type = "inputType"                        
                        v-model = "inputValue"
                        :placeholder = "label !== '' ? placeholder : ''"
                        @input = "emitInputValue"
                        :class = "{ hasvalue: inputValue !== null }"
                        id="text-input"
                        :max_value = "max_value"
                        @focus="isFocused = true"
                        @blur="isFocused = false"
                    />
                </div>
                <span class="error-text">{{ errors[0] }}</span>
            </div>
        </ValidationProvider>
    </div>
</template>

<script>
    import TitleAndExplanation from '../common/TitleAndExplanation.vue';
    import { ValidationProvider } from 'vee-validate';
    import { extend } from 'vee-validate';
    import { required, email, numeric } from 'vee-validate/dist/rules';

    // Override de reglas
    extend('email', {
        ...email,
        message: 'Introduce un email válido.'
    });
    extend('required', {
        ...required,
        message: 'Este campo es obligatorio.'
    });
    extend('number', {
        ...numeric,
        message: 'Introduce solo números.'
    });
    extend('max_value', {
        params: ['max_value'],
        validate(value, { max_value }) {
            return Number(value) <= Number(max_value);
        },
        message: 'El valor introducido es demasiado alto.'
    });
    extend('phone', {
        validate: (value) => {
            const phoneRegex = /^\d{9,15}$/;
            return phoneRegex.test(value);
        },
        message: 'Introduce un número de teléfono válido (9-15 dígitos).'
    });
    
    export default {
        name: 'InputField',
        components: {
            TitleAndExplanation,
            ValidationProvider
        },
        data() {
            return {
                inputValue: this.currentValue,
                isFocused: false,
                isEmpty: true,
                rules: {}                
            };
        },
        props: {
            placeholder: {
                type: String,
                default: '...'
            },
            currentValue: {
                type: [String, Number],
                default: ''
            },
            inputType: {
                type: String,
                default: 'text', 
                validator: function(value) {
                    return ['text', 'number', 'email', 'tel'].includes(value);
                }
            },
            label: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: ''
            },
            explanation: {
                type: String,
                default: ''
            },
            isRequired:{
                type: Boolean,
                default: false
            },
            max_value: {
                type: Number,
                default: null
            }

        },
        mounted() {
            this.setRules();
        },
        methods: {
            emitInputValue() {
                const value = this.inputValue;
                this.$emit('valueChanged', value);
            },
            setRules() {
                if(this.isRequired) this.rules = { required: true };
                if (this.inputType === 'email') {
                    this.rules = { ...this.rules, email: true };
                }
                if (this.inputType === 'tel') {
                    this.rules = { ...this.rules, phone: true };
                }
                if (this.inputType === 'number') {
                    this.rules = { ...this.rules, number: true };
                    if (this.max_value && this.max_value !== undefined) {
                        this.rules = { ...this.rules, max_value: this.max_value };
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .input-field-container {
        width: 100%;
        position: relative;
    }
    .input-field {
        position: relative;
        width: 100%;
    }
    .input-field input {
        height: 56px;
        width: 100%;
        font-size: var(--font-size-inputs);
        outline: none;
        box-sizing: border-box;
        transition: border-color 0.2s ease;
        border: 1px solid var(--gray-light);
        border-radius: var(--border-radius);
        padding: 8px 16px;
    }
    .input-field input.hasvalue,
    .input-field input:focus {
        padding: 20px 15px 10px;
    }
    .input-field input::placeholder {
        font-size: var(--font-size-inputs);
        font-weight: var(--font-weight-medium);
        color:var(--dark);
    }    
    .input-field label {
        position: absolute;
        top: 50%;
        left: 10px;
        transform: translateY(-50%);
        background: var(--white);
        padding: 0 5px;
        font-size: var(--font-size-inputs);
        color: var(--gray);
        font-weight: var(--font-weight-medium);
        pointer-events: none;
        transition: all 0.2s ease;
    }
    .input-field label.active {
        top: 12px;
        font-size: 10px;
        color: var( --gray);
    }
    .input-field.error {
        margin-bottom: 1px;
    }
    .input-field.error input{
        border-color: var(--danger);
    }
    .input-field.error label{
        color: var(--danger);
    }
    .error-text {
        font-size: 12px;
        color: var( --danger);
        line-height: 3px;
    }

    /* eliminar flechitas por defecto */
    .input-field input[type="number"] {
        -moz-appearance: textfield; /* Firefox */
    }
    .input-field input[type="number"]::-webkit-outer-spin-button,
    .input-field input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none; /* Chrome, Safari, Edge */
        margin: 0;
    }

    /* MOVIL */
    @media (max-width: 768px) {
        .input-field-container {
            /* width: 360px; */
            /* width: 328px; */
        }
        /* .input-field {
            width: 100%;
        } */
    }

</style>
